import { array, func, number } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addTrendBoardTag, deleteTrendBoardTag } from '@services/trendResearch';

import { TAG_COLOR_LIST } from '@/constants/constant';

const MoodBoardTag = ({
	moodBoardId,
	currentProductTagList = [],
	allTagList,
	fetchAllTags,
	updateTagList
}) => {
	const dispatch = useDispatch();
	const [text, setText] = useState('');
	const [activeColorCode, setActiveColorCode] = useState('#DBFFE5');

	const renderUnusedTags = () => {
		let usedTagIds = currentProductTagList?.map((item) => item.id);
		if (usedTagIds) {
			return allTagList?.filter((item) => !usedTagIds.includes(item.id));
		} else {
			return allTagList;
		}
	};

	useEffect(() => {
		(async () => {
			await fetchAllTags(text);
		})();
	}, [text]);

	const createTag = async (id) => {
		try {
			dispatch(openLoader());
			let postData = { text, colorCode: activeColorCode };
			if (id) {
				postData['id'] = id;
			}
			const data = await addTrendBoardTag(moodBoardId, postData);
			updateTagList(data);
			setText('');
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const isActiveColor = (code) => (activeColorCode === code ? 'single-color active' : 'single-color');

	const toggleActiveColor = (code) => {
		setActiveColorCode(code);
	};

	const createAbleTags = () => {
		if (renderUnusedTags(allTagList)?.length === 0 && text !== '') {
			return (
				<div className="create">
					<p className="px-3 py-1 d-flex align-items-center" onClick={() => createTag()}>
						<span className="semibold-14">Create</span>
						<span className="status radius ml-2" style={{ background: activeColorCode }}>
							{text}
						</span>
					</p>
					<div className="colors">
						{TAG_COLOR_LIST?.map((item) => (
							<span
								key={`tag_color_${item}`}
								className={`single-color ${isActiveColor(item)}`}
								onClick={() => toggleActiveColor(item)}
								style={{ background: item }}
							/>
						))}
					</div>
				</div>
			);
		}
	};

	const removeTag = async (id) => {
		try {
			dispatch(openLoader());
			const data = await deleteTrendBoardTag(moodBoardId, id);
			updateTagList(data);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const renderExistingTags = () => {
		return currentProductTagList?.map((item, index) => {
			return (
				<span className="status radius" key={`tag_${index}`} style={{ background: item.colorCode }}>
					{item.text}{' '}
					<img
						onClick={() => removeTag(item.id)}
						src={`${process.env.PUBLIC_URL}/icons/chip-close.svg`}
						className="ml-1 cursor-pointer"
						alt=""
					/>
				</span>
			);
		});
	};

	const renderAllTags = () => {
		return renderUnusedTags(allTagList)?.map((item, index) => {
			return (
				<p
					className="px-3 py-1 d-flex align-items-center"
					key={`all_tags_${index}`}
					onClick={() => createTag(item.id)}
				>
					<span className="status radius" style={{ background: item.colorCode }}>
						{item.text}
					</span>
				</p>
			);
		});
	};

	return (
		<div className="select-tag-dropdown">
			<div className="py-2 px-3">
				<div className="selected-tags design-tags mb-2">{renderExistingTags()}</div>
				<div className="input-tag">
					<input
						type="text"
						autoComplete="off"
						placeholder="Select or create new"
						value={text}
						onChange={(e) => setText(e.target.value)}
						onKeyDown={(event) => {
							if (event.key === 'Enter') {
								createTag();
							}
						}}
					/>
					<img
						src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`}
						className="cursor-pointer"
						alt=""
					/>
				</div>
			</div>
			{createAbleTags()}
			<div className="suggested-tags scroll-y-label mt-1">{renderAllTags()}</div>
		</div>
	);
};

MoodBoardTag.propTypes = {
	moodBoardId: number.isRequired,
	currentProductTagList: array.isRequired,
	allTagList: array.isRequired,
	fetchAllTags: func.isRequired,
	updateTagList: func.isRequired
};

export default MoodBoardTag;
